import Axios from 'axios';
import Cookies from 'js-cookie';

const platform = process.env.REACT_APP_PLATFORM;
const isDev = process.env.NODE_ENV === 'development';

function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

export default {
  /**
   * 测试环境和开发时，添加platform至url中
   * @param url 路径
   * @param data
   */
  getJsonWithToken(url: string, data?: any) {
    // const _url = isDev ? url : `/${platform}${url}`;
    const _url = url;
    return Axios.get(updateQueryStringParameter(_url, 'ts', new Date().getTime()), {
      params: data,
      headers: {
        'Content-Type': 'application/json',
        token: Cookies.get('cwsso_token') || Cookies.get('token')
      }
    })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  postJsonWithToken(url: string, data?: any, options?: any) {
    const _url = isDev ? url : `/${platform}${url}`;
    return Axios.post(
      updateQueryStringParameter(_url, 'ts', new Date().getTime()),
      {
        ...data
      },
      {
        headers: {
          'Content-Type': 'application/json',
          token: Cookies.get('cwsso_token') || Cookies.get('token')
        }
      }
    )
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  },
  putWithToken(url: string, data?: any, options?: any) {
    const _url = isDev ? url : `/${platform}${url}`;
    return Axios.put(
      updateQueryStringParameter(_url, 'ts', new Date().getTime()),
      {
        ...data
      },
      {
        headers: {
          'Content-Type': 'application/json',
          token: Cookies.get('cwsso_token') || Cookies.get('token')
        }
      }
    )
      .then(res => {
        return res.data;
      })
      .catch(err => {
        return err;
      });
  }
};
